module.exports = __webpack_public_path__ + "static/media/file-excel.84701a06.svg";